import { createApp } from 'vue'
import axios from './axios';
import store from "./store";
import i18n from "../plugins/i18n";
import App from './App.vue'
import router from './router';

const rootProps = {
    language: window.currentLanguage,
}

axios.get(import.meta.env.VITE_APP_TRANSLATION_FILE_URL+"?lang="+window.currentLanguage)
    .then(data => {
        const app = createApp(App,rootProps);
        app.use(router);
        app.use(store);
        const i18nStrings = data.data;
        app.use(i18n,i18nStrings);
        app.mount('#app')
    }).catch((error) => {
        console.log(error);
    });


